import { computed, ref } from '@vue/composition-api';
import store from '@/store.ts';

export const tenantId = computed(() =>
  _.get(store.getters['tenants/selectedTenant'], '_id', '')
);

export const assetOrDevice = ref(null);

export const type = computed(() =>
  _.get(assetOrDevice.value, '_source.type', 'N/A')
);

export const model = computed(() =>
  _.get(assetOrDevice.value, '_source.model', 'N/A')
);

export const reference = computed(() =>
  _.get(assetOrDevice.value, '_source.reference', 'N/A')
);

export const measureTypes = computed(() =>
  Object.keys(_.get(assetOrDevice.value, '_source.measures', []))
);

export const currentTabType = computed(() => {
  if (!measureTypes.value[currentHistoryTabIdx.value]) {
    return;
  }
  return measureTypes.value[currentHistoryTabIdx.value];
});

export const currentMeasurePath = computed(() => {
  let path;
  switch (currentTabType.value) {
    case 'movement':
      path = 'moving';
      break;
    case 'temperature':
      path = 'degree';
      break;
    case 'position':
      path = 'point';
      break;
    default:
      path = null;
  }
  return path;
});

export const measures = ref([]);

export const tableMeasures = computed(() => {
  return measures.value.map(i => {
    const updatedAt = _.get(
      i,
      `_source.asset.measures[${currentTabType.value}]updatedAt`,
      null
    );
    const measure = _.get(
      i,
      `_source.asset.measures[${currentTabType.value}][${currentMeasurePath.value}]`,
      null
    );
    return {
      date: new Date(updatedAt).toLocaleString(),
      measure
    };
  });
});

export const currentHistoryTabIdx = ref(0);
